import * as Yup from 'yup';
import { Formik } from 'formik';
import React, { Fragment } from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { applicantStore } from '../ApplicantStore';
import { FormField } from 'components/layout/form-fields/FormField';

const ValidationSchema = Yup.object().shape({
	email: Yup.string().email().required().label('Email')
});

export default class SendCandidateInviteModal extends ModalComponent {
	getInitialValues() {
		return {
			email: ''
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.sendInvite(values);
				}}>
				{formikBag =>
					this.renderModalContainer(formikBag, 'SendCandidateInviteModal')
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<FormField
							required
							className="has-text-left"
							label="Email (Google Account)"
							field="email"
							type="text"
							placeholder="email@example.com"
							icon="fa-envelope"
						/>
					</div>
				</div>
			</Fragment>
		);
	}

	async sendInvite(values) {
		const result = await applicantStore.inviteCandidate({
			applicantId: this.props.applicant.id,
			email: values.email
		});

		this.resultNotification(
			result,
			'Invitation',
			'Send',
			'Send Invitation',
			'Invitation email sent successfully.'
		);
	}
}
